/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MicroConsultingFreelancerEligibility
 */
export interface MicroConsultingFreelancerEligibility {
    /**
     * 
     * @type {boolean}
     * @memberof MicroConsultingFreelancerEligibility
     */
    isEligible: boolean;
    /**
     * 
     * @type {string}
     * @memberof MicroConsultingFreelancerEligibility
     */
    freelancerCompanyId?: string;
}

/**
 * Check if a given object implements the MicroConsultingFreelancerEligibility interface.
 */
export function instanceOfMicroConsultingFreelancerEligibility(value: object): value is MicroConsultingFreelancerEligibility {
    if (!('isEligible' in value) || value['isEligible'] === undefined) return false;
    return true;
}

export function MicroConsultingFreelancerEligibilityFromJSON(json: any): MicroConsultingFreelancerEligibility {
    return MicroConsultingFreelancerEligibilityFromJSONTyped(json, false);
}

export function MicroConsultingFreelancerEligibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MicroConsultingFreelancerEligibility {
    if (json == null) {
        return json;
    }
    return {
        
        'isEligible': json['isEligible'],
        'freelancerCompanyId': json['freelancerCompanyId'] == null ? undefined : json['freelancerCompanyId'],
    };
}

export function MicroConsultingFreelancerEligibilityToJSON(value?: MicroConsultingFreelancerEligibility | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isEligible': value['isEligible'],
        'freelancerCompanyId': value['freelancerCompanyId'],
    };
}

